import React, { useState, useEffect } from 'react';
import { Card, Table, DatePicker, Space, Tag, Typography, Spin } from 'antd';
import { AuditOutlined } from '@ant-design/icons';
import api from '../utils/api';

const { Title } = Typography;
const { RangePicker } = DatePicker;

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([]);

  const fetchLogs = async (startDate, endDate) => {
    setLoading(true);
    try {
      const response = await api.get(`/api/audit-logs?start_date=${startDate}&end_date=${endDate}`);
      setLogs(response.data);
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial fetch for last 30 days
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 30);
    fetchLogs(start.toISOString().split('T')[0], end.toISOString().split('T')[0]);
  }, []);

  const columns = [
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (action) => (
        <Tag color={getActionColor(action)}>{action.replace(/_/g, ' ').toUpperCase()}</Tag>
      ),
    },
    {
      title: 'Details',
      dataIndex: 'details',
      key: 'details',
      render: (details) => (
        <div style={{ maxWidth: '300px', whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(details, null, 2)}
        </div>
      ),
    },
    {
      title: 'Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (timestamp) => new Date(timestamp).toLocaleString(),
    },
    {
      title: 'IP Address',
      dataIndex: 'ip_address',
      key: 'ip_address',
    },
  ];

  const getActionColor = (action) => {
    const actionColors = {
      grant_access: 'green',
      revoke_access: 'red',
      modify_user: 'blue',
      modify_department: 'purple',
      default: 'default',
    };
    return actionColors[action] || actionColors.default;
  };

  const handleDateRangeChange = (dates) => {
    if (!dates) {
      return;
    }
    setDateRange(dates);
    fetchLogs(
      dates[0].format('YYYY-MM-DD'),
      dates[1].format('YYYY-MM-DD')
    );
  };

  return (
    <Card className="audit-logs-container">
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={2}>
            <Space>
              <AuditOutlined />
              Audit Logs
            </Space>
          </Title>
          <RangePicker
            onChange={handleDateRangeChange}
            value={dateRange}
            style={{ marginBottom: 16 }}
          />
        </div>
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={logs}
            rowKey="id"
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showQuickJumper: true,
            }}
            scroll={{ x: true }}
          />
        </Spin>
      </Space>
    </Card>
  );
};

export default AuditLogs;
